import {
  StyledBanner,
  StyledDescription,
  StyledImage,
  StyledImageContainer,
  StyledTextContainer,
  StyledTitle
} from "./styles";

import bannerImage from "@assets/imgs/about_banner_image.png";
import React, { FC, memo } from "react";
import { useTranslations } from "next-intl";

interface BannerProps {
  className?: string;
  style?: React.CSSProperties;
}

const _Banner: FC<BannerProps> = (props) => {
  const { ...restProps } = props;

  const t = useTranslations("AboutUsPage");

  return (
    <StyledBanner {...restProps}>
      <StyledTextContainer>
        <StyledTitle>{t("banner.title")}</StyledTitle>
        <StyledDescription>
          {t("banner.subtitle_1")}
          <br />
          {t("banner.subtitle_2")}
        </StyledDescription>
      </StyledTextContainer>
      <StyledImageContainer>
        <StyledImage src={bannerImage} alt={t("banner.title")} priority />
      </StyledImageContainer>
    </StyledBanner>
  );
};

export const Banner = memo(_Banner);
